import * as actionTypes from 'constants/action-types';
import { action } from 'typesafe-actions';

export type ToggleOpenDDPanelAction = {
  type: typeof actionTypes.TOGGLE_DD_PANEL_OPEN;
};

export const toggleOpenDDPanel = () => action(actionTypes.TOGGLE_DD_PANEL_OPEN);

export type SetDataEntitySelectedAction = {
  type: typeof actionTypes.DATA_ENTITY_SELECTED;
  payload: string | undefined;
};
export const setDataEntitySelected = (selected: string | undefined) =>
  action(actionTypes.DATA_ENTITY_SELECTED, selected);
